'use strict';

module.exports = require('./node-progress');